import React from 'react';

import { ProfileJoint } from '@paragon/contract-library';
import { RaycastOrder, RenderOrder } from '@paragon/three-shared';

import { useAppDispatch, useAppSelector } from '../../components/hooks';
import { leftClickItem } from '../../store/actions/sceneInteractionActions';
import { getSingleSelectedItemEntryOrNull } from '../../store/selectors/getSelectedItemSelector';

interface Props {
  readonly joint: ProfileJoint;
  readonly registerForRaycasting: boolean;
}

export function ProfileJointVisual({ joint, registerForRaycasting }: Props) {
  const dispatch = useAppDispatch();

  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);
  const selected = selectedEntry?.type === 'profileJoint' && selectedEntry.item.guid === joint.guid;

  const raycast = registerForRaycasting ? true : undefined;

  return (
    <mesh
      userData-raycastOrder={RaycastOrder.ProfileJointVisual}
      renderOrder={RenderOrder.ProfileJointVisual}
      position={[joint.location.x, joint.location.y, 0]}
      onClick={raycast && ((event) => dispatch(leftClickItem(event, { item: joint, type: 'profileJoint' })))}
      onPointerOver={raycast && ((event) => event.stopPropagation())}
      onPointerOut={raycast && ((event) => event.stopPropagation())}
    >
      <sphereGeometry args={[1, 8, 8]} />
      <meshBasicMaterial
        color={selected ? 0xff0022 : 0x2200ff}
        transparent
        depthTest={false}
        depthWrite={false}
        opacity={1}
      />
    </mesh>
  );
}
